module.exports = __webpack_public_path__ + "fonts/GT-Eesti-Display-Regular.8b3af9b.woff";